// extracted by mini-css-extract-plugin
export default {"input":"SimpleOtpInput_input__RDsWr","wrapper":"SimpleOtpInput_wrapper__gEOmp"};